// extracted by mini-css-extract-plugin
export var button = "_ak-7";
export var buttonRow = "_ak-6";
export var fadeIn = "_ak-1";
export var gradient = "_ak-0";
export var panel = "_ak-2";
export var panelIn = "_ak-3";
export var subtitle = "_ak-5";
export var title = "_ak-4";